goog.provide("shadow.js.shim.module$$mui$material$AlertTitle$default");
shadow.js.shim.module$$mui$material$AlertTitle$default = shadow.js.require(400, {})["default"];
